import instance from "./axios";
import baseUrl from "@/env";

export async function startPracticeSession(data) {
  const res = await instance.post(
    `${baseUrl}/question/practice/session/start`,
    data
  );
  return res.data;
}

export async function savePracticeRecord(data) {
  const res = await instance.post(
    `${baseUrl}/question/practice/record/save`,
    data
  );
  return res.data;
}

export async function saveCorrectionRecord(data) {
  const res = await instance.post(
    `${baseUrl}/question/practice/correction/record/save`,
    data
  );
  return res.data;
}

export async function finishPracticeSession(data) {
  const res = await instance.post(
    `${baseUrl}/question/practice/session/finish`,
    data
  );
  return res.data;
}

export async function getPracticeSessionPage(params) {
  const res = await instance.get(`${baseUrl}/question/practice/session/page`, {
    params
  });
  return res.data;
}
